export default __webpack_public_path__ + "static/Klasse_Steira_WB-d25bf6d72130b8974c77cc6b5d4c6c77.jpg";